<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex flex-col gap-4">
                <div class="flex items-center justify-between">
                    <div>
                        <vx-label size="md">Sub Team</vx-label>
                        <div class="text-sm text-slate-700">
                            Does this team need to be organized under a parent team?
                        </div>
                    </div>

                    <vx-toggle v-model="subTeam" size="lg"></vx-toggle>
                </div>

                <div v-if="subTeam">
                    <vx-label size="md">Parent Team</vx-label>
                    <vx-selectable
                        v-model="form.parent_id"
                        :options="teams"
                        @search="search"
                        size="lg"
                        label="name"
                        :reduce="(option) => option.id"
                        :clearable="false"
                        :error="displayFirstError(validate.parent_id.$errors)"
                    ></vx-selectable>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>
<script setup>
import { VxExpandableCard, VxToggle, VxLabel, VxSelectable } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { requiredIf } from '@vuelidate/validators';
import { ref, watch } from 'vue';
import { adminTeamsClient } from '~/services';
import debounce from '~/utils/debounce';
import { displayFirstError } from '~/utils/validation';

const form = defineModel({
    type: Object,
    required: true,
});

const subTeam = ref(true);

const teams = ref([]);

const search = debounce((query) => {
    adminTeamsClient
        .getTeams({
            query,
            is_parent: 1,
            status: 'active',
        })
        .then(
            (res) =>
                (teams.value = res.data.data.map((team) => ({
                    ...team,
                    name: `${team.id} - ${team.name}`,
                })))
        );
});

search();

watch(
    () => subTeam.value,
    (value) => {
        if (!value) {
            form.value.parent_id = null;
        }
    }
);

const validate = useVuelidate(
    {
        parent_id: {
            requiredIf: requiredIf(() => Boolean(subTeam.value)),
        },
    },
    form
);
</script>
